import { Component, OnInit } from '@angular/core';
import { CfetBaseComponent, CfetService, CFETILMEndpointsConstant, CfetPageNamesConstant } from '../../cfet-core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'app-utf-unauth-page-form',
    templateUrl: './utf-unauth-page-form.component.html',
    styleUrls: ['./utf-unauth-page-form.component.scss'],
    standalone: false
})
export class UtfUnauthPageFormComponent extends CfetBaseComponent implements OnInit {
  emailAddressForm: UntypedFormGroup;
  emailAddress: UntypedFormControl;
  emailAddressError: boolean;
  disabledContinueButton = true;
  emailAddressResponse: any;
  displayUserID = false;
  showInfoSection = false;
  userID = '';
  userId: any;
  showDupeErrorMsg = false;
  param = '';
  uRl = '';
  unAuth: any;
  httpHeaders: any = {};
  amEmailVerified: any;
  amFirstName: any;
  amLastName: any;
  openCancelModal = '';
  showCancelModal = false;

  constructor(private cfetService: CfetService,
    private router: Router) {
    super();
  }

  ngOnInit() {
    this.emailAddress = new UntypedFormControl('', [Validators.required]);
    this.emailAddressForm = new UntypedFormGroup({
      emailAddress: this.emailAddress
    });

    if (sessionStorage.getItem('AMUTFHeaders') && Object.keys(sessionStorage.getItem('AMUTFHeaders')).length !== 0) {
      this.httpHeaders = JSON.parse(sessionStorage.getItem('AMUTFHeaders'));
      this.amEmailVerified = this.httpHeaders.isEmailVerified;
      this.amFirstName = this.httpHeaders.firstname;
      this.amLastName = this.httpHeaders.lastname;
    }

    if (sessionStorage.getItem('userID') && Object.keys(sessionStorage.getItem('userID')).length !== 0) {
      this.userId = JSON.parse(sessionStorage.getItem('userID'));
    }
  }

  validateEmailAddress() {
    const emailRegex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/);
    if (this.emailAddress.value === '' || this.emailAddress.value === undefined || this.emailAddress.value === null) {
      this.disabledContinueButton = true;
    } else {
      this.emailAddressError = !emailRegex.test(this.emailAddress.value);
      if (this.emailAddressError) {
        this.disabledContinueButton = true;
        this.showDupeErrorMsg = false;
      } else {
        this.disabledContinueButton = false;
      }
    }
  }

  onChangeEmail() {
    this.showDupeErrorMsg = false;
  }

  continue(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.KeyCode === 13) {
      const request = {
        'userid': this.emailAddress.value.trim(),
        'company_id': environment.companyId,
        'notification_value': '',
        'notification_method': 'list',
        'notification_flow': 'actv'
      };
      this.cfetService.cfetLivePost(request, CFETILMEndpointsConstant.VERIFY_IDENTITY_ACTIVATION).subscribe((data) => {
        /* do nothing */
      }, (error) => {
        if (error && error.error && error.error.errorcode && error.error.errorcode === 1033) {
          this.unAuth = true;
          sessionStorage.setItem('userID', JSON.stringify(this.emailAddress.value));
          sessionStorage.setItem('unAuth', JSON.stringify(this.unAuth));
          this.router.navigate([CfetPageNamesConstant.CUSTOMER_PERSONAL_INFORMATION_UTF]);
        } else {
          this.showDupeErrorMsg = true;
          this.emailAddressError = false;
        }
      });
    }
  }

  redirectUrl(url) {
    if (this.isEncoded(url)) {
      window.location.href = decodeURIComponent(url);
    } else {
      window.location.href = url;
    }
  }

  isEncoded(url) {
    if (url != '') {
      return url !== decodeURIComponent(url);
    }
  }

  cancelModal(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }


  closeModal(event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }

}
